/* eslint-disable import/export */
import React from "react";
export function isChildOfType(child, type) {
    var _a, _b;
    if (typeof child === "undefined" || child === null)
        return false;
    if (typeof child === "string") {
        return type === "text";
    }
    if (typeof child === "number") {
        return type === "number";
    }
    if (React.isValidElement(child)) {
        if (typeof type === "string") {
            return child.type === type;
        }
        // React Hot Loader 会对组件进行代理。使用 createElement() 返回的 element.type 才是实际的类型
        // remark: https://github.com/gaearon/react-hot-loader/issues/304#issuecomment-223222772
        var createdElementType = React.createElement(type, {}).type;
        var childDisplayName = (_a = child.type) === null || _a === void 0 ? void 0 : _a.displayName;
        var createdElementDisplayName = (_b = React.createElement(type, {}).type) === null || _b === void 0 ? void 0 : _b.displayName;
        //  forwardRef 造成不同引用 type 的 render 函数也不同，增加 childDisplayName 的判断
        return (child.type === createdElementType ||
            childDisplayName === createdElementDisplayName);
    }
    return false;
}
/* eslint-enable import/export */
//# sourceMappingURL=is-child-of-type.js.map